import { toast } from 'sonner';

export function useToast() {
  const notifySuccess = (message: string) => {
    toast.success(message, {
      duration: 3000,
    });
  };

  const notifyError = (message: string) => {
    toast.error(message, {
      duration: 4000,
    });
  };

  const notifyWarning = (message: string) => {
    toast.warning(message, {
      duration: 5000,
    });
  };

  return {
    notifyError,
    notifySuccess,
    notifyWarning,
  };
}
